import script from "./ProjectVideos.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectVideos.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectVideos.vue?vue&type=style&index=0&id=20b503a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b503a2"]])

export default __exports__